module.exports = require("@angular/core");


//////////////////
// WEBPACK FOOTER
// external "@angular/core"
// module id = 2
// module chunks = 0